import {
  GetShiftPlanningShiftsResponse,
  ShiftPlanningBusinessUnitsData,
  ShiftPlanningJobTypesData,
  ShiftPlanningParams,
  ShiftPlanningPartnerUnitsData,
} from './shift-planning-service.types';
import { HqApiService } from './hqApiService';

class ShiftPlanningService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getShiftPlanningShifts({
    fromDate,
    company,
    branchOfficeIds,
    departmentIds,
    pageParam,
    pageSizeParam,
    jobType,
    filledStatus,
    partner,
    isFreelance,
    isTempWork,
    areFreelanceApplications,
    areTempworkApplications,
    areNoApplications,
  }: ShiftPlanningParams) {
    const response = await this.hqApiService.get<GetShiftPlanningShiftsResponse>({
      params: {
        page: pageParam,
        pageSize: pageSizeParam,
        fromDate: fromDate?.toISO(),
        companyId: company,
        branchOffices: branchOfficeIds,
        departments: departmentIds,
        jobType: jobType,
        filledStatus,
        partnerId: partner,
        isFreelance,
        isTempWork,
        areFreelanceApplications,
        areTempworkApplications,
        areNoApplications,
      },
      path: 'shift-planning/shifts',
    });

    return response;
  }

  public async getShiftPlanningBusinessUnitsData() {
    const response = await this.hqApiService.get<ShiftPlanningBusinessUnitsData>({
      path: 'shift-planning/business-units',
    });

    return response;
  }

  public async getShiftPlanningJobTypesData() {
    const response = await this.hqApiService.get<ShiftPlanningJobTypesData>({
      path: 'shift-planning/job-types',
    });
    return response;
  }

  public async getShiftPlanningPartnersData() {
    const response = await this.hqApiService.get<ShiftPlanningPartnerUnitsData>({
      path: 'shift-planning/partners',
    });

    return response;
  }
}

export { ShiftPlanningService };
